export type Breadcrumb = {
  url: string;
  title: string;
}

export const learningBreadcrumb: Breadcrumb = { url: '/learning/', title: 'Learning center' };
export const commandLineToolsBreadcrumb: Breadcrumb = { url: '/learning/#command-line-tools', title: 'Command line tools' };
export const emailBreadcrumb: Breadcrumb = { url: '/learning/mx-vs-spf-vs-dmarc-vs-dkim-vs-bimi/', title: 'Email and the DNS' };
export const aboutBreadcrumb: Breadcrumb = { url: '/about/', title: 'About' };
